// `useNetworkConfig()` — client hook that returns the full network
// config (apiUrl, rpcUrl, programId, apiKey) for the USER'S currently-
// selected network. Reactive: re-runs when the user toggles networks.
//
// Use this anywhere a client component needs a per-network value that
// used to come from `env.NEXT_PUBLIC_API_URL` / `_RPC_URL` / etc.

'use client';

import { c as _c } from "react/compiler-runtime";
import { useUserNetwork } from './client';
import { getNetworkConfig, type NetworkConfig } from './config';
export function useNetworkConfig() {
  const $ = _c(2);
  const {
    network
  } = useUserNetwork();
  let t0;
  if ($[0] !== network) {
    t0 = getNetworkConfig(network);
    $[0] = network;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}